import React, { forwardRef } from 'react';
import { Calendar } from 'lucide-react';
interface DatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(({
  label,
  error,
  helperText,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-93">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-94">
            {label}
          </label>}
        <div className="relative" data-id="element-95">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" data-id="element-96">
            <Calendar className="w-4 h-4" data-id="element-97" />
          </div>
          <input type="date" ref={ref} className={`
              block w-full h-10 rounded-lg border bg-white text-sm transition-colors
              focus:outline-none focus:ring-2 focus:ring-[#1B6B3A]/20 focus:border-[#1B6B3A]
              disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed disabled:border-gray-200
              ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20 text-red-900' : 'border-gray-300 text-gray-900'}
              pl-10 pr-3
              ${className}
            `} {...props} data-id="element-98" />
        </div>
        {error && <p className="mt-1.5 text-sm text-red-600" data-id="element-99">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500" data-id="element-100">{helperText}</p>}
      </div>;
});
DatePicker.displayName = 'DatePicker';